import { Box, Grid, FormGroup, FormLabel, FormControlLabel, Switch, Checkbox } from '@mui/material';
import { ADMIN_PERMISSION_GROUPS, ADMIN_PERMISSION_TYPES } from '@localstack/constants';
import { AdminPermission } from '@localstack/types';

export const PermissionCheckboxes = ({
  currentPermissions,
  isSelf,
  togglePermission,
}: {
  currentPermissions: AdminPermission[];
  isSelf: boolean;
  togglePermission: (permission: AdminPermission) => void;
}): JSX.Element => {
  return (
    <Box display="flex" flexWrap="wrap" mt={2} rowGap="1em">
      {Object.entries(ADMIN_PERMISSION_GROUPS).map(([title, perms]) => (
        <Grid xs={12} sm={6} key={title}>
          <FormGroup>
            <FormLabel component="legend">{title}</FormLabel>
            {perms.map((permission) => {
              const label = ADMIN_PERMISSION_TYPES[permission];
              const isChecked = currentPermissions.includes(permission);
              const isSuperAdmin = permission === AdminPermission.SUPER_ADMIN;
              const isAnnouncements = permission === AdminPermission.ANNOUNCEMENTS;

              const isSuperAdminActive = currentPermissions.includes(AdminPermission.SUPER_ADMIN);
              const isReadPermission = permission.endsWith(':read');
              const correspondingWrite = permission.replace(':read', ':write') as AdminPermission;
              const isWriteActive = currentPermissions.includes(correspondingWrite);

              const isDisabled = isSelf || (isSuperAdminActive && !isSuperAdmin) || (isReadPermission && isWriteActive);

              return (
                <FormControlLabel
                  key={permission}
                  label={label}
                  control={
                    isAnnouncements || isSuperAdmin ? (
                      <Switch
                        color="primary"
                        checked={isChecked}
                        onChange={() => !isDisabled && togglePermission(permission)}
                        disabled={isDisabled}
                      />
                    ) : (
                      <Checkbox
                        checked={isChecked}
                        onChange={() => !isDisabled && togglePermission(permission)}
                        disabled={isDisabled}
                      />
                    )
                  }
                />
              );
            })}
          </FormGroup>
        </Grid>
      ))}
    </Box>
  );
};
